import { render, staticRenderFns } from "./GeneralActionIconButton.vue?vue&type=template&id=224f69fd&"
import script from "./GeneralActionIconButton.vue?vue&type=script&lang=js&"
export * from "./GeneralActionIconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports